import Papa from 'papaparse';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import find from 'lodash/find';

const variableRegexp = /%+[a-z_0-9]+%/gi;

const trimObjValues = obj =>
  reduce(
    obj,
    (acc, value, key) => {
      acc[key.trim()] = value.trim();
      return acc;
    },
    {},
  );

const parseFile = file =>
  new Promise(resolve => {
    const results = [];
    let rowIndex = 0;
    Papa.parse(file, {
      skipEmptyLines: true,
      header: true,
      step: ({ data, errors }) => {
        if (!errors.length) {
          results.push(trimObjValues(data));
        }
        rowIndex += 1;
      },
      complete: () => {
        resolve({
          data: results,
          noOfRows: rowIndex - 1,
        });
      },
    });
  });

export const getFileData = (file, pageIndex, perPage) =>
  file ? parseFile(file, pageIndex, perPage) : {};

export const getVariablePlaceholdersInString = string => {
  const iterator = string.matchAll(variableRegexp);
  const variables = [];
  let currentVal = iterator.next();
  while (!currentVal.done && currentVal.value) {
    variables.push(currentVal.value[0].replaceAll('%', ''));
    currentVal = iterator.next();
  }
  return variables;
};

export const replacePlaceholdersWithVariables = (string, variables) => {
  if (!string || !variables) return string;
  let finalString = string;
  const iterator = string.matchAll(variableRegexp);
  let currentVal = iterator.next();
  while (!currentVal.done && currentVal.value) {
    const [name, key] = currentVal.value;
    const variableValue = get(variables, key);
    if (variableValue) finalString = finalString.replace(name, variableValue);
    currentVal = iterator.next();
  }
  return finalString;
};

export const getFieldInObject = (variablesObj, fieldName) => {
  if (variablesObj[fieldName]) return variablesObj[fieldName];
  const regExp = new RegExp(fieldName, 'i');
  return find(variablesObj, (_, key) => regExp.test(key));
};
